import React from "react";
import { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import momenttimezone from "moment-timezone";
import { useGlobalState } from "../Context/GlobalStateContext";
type MyNotificationsProps = {
  ObjectType: any;
  ObjectIds: any;
};
function MyNotifications(props: MyNotificationsProps) {
  const globalState = useGlobalState();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let isRead = params.get("ur") as any;

  const [showAnimation, setShowAnimation] = useState(false);
  const [notificationsTypeList, setNotificationsTypeList] = useState<any>([]);
  const [notificationsListsData, setNotificationsListsData] = useState<any>([]);

  const [notificationsFilters, setNotificationsFilters] = useState({
    All: true,
    Unread: false,
    Flagged: false,
    NotificationsIDs: "",
    LastLoadedId: 0,
    NumberOfRecords: 100,
  });

  useEffect(() => {
    if (isRead && isRead != "") {
      notificationsFilters.Unread = true;
    }
    getNotificationsTypeListsData();
  }, []);

  useEffect(() => {
    getNotificationsData();
  }, [notificationsFilters]);

  function getNotificationsTypeListsData() {
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFINotification/GetNotificationsListsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          globalState.setUpdateNotificationCount(
            !globalState.UpdateNotificationCount
          );
          let thisList = [];
          if (l_response && l_response[0]) {
            thisList = l_response[0];
          }

          if (
            notificationsTypeList &&
            notificationsTypeList.length > 0 &&
            notificationsTypeList.length == thisList.length
          ) {
            for (let index = 0; index < thisList.length; index++) {
              thisList[index].Selected = notificationsTypeList[index].Selected;
            }
          }

          setNotificationsTypeList(thisList);
          console.log(thisList);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getNotificationsData() {
    let object = {} as any;
    object.objecttype = props.ObjectType;
    object.objectids = props.ObjectIds;
    object.linkedobjecttype = 1;
    object.linkedobjectids = "";
    object.unread = notificationsFilters.Unread;
    object.flagged = notificationsFilters.Flagged;
    object.ntids = notificationsFilters.NotificationsIDs;
    object.stdt = "";
    object.eddt = "";
    object.lastloadedid = notificationsFilters.LastLoadedId;
    object.numberofrecords = notificationsFilters.NumberOfRecords;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFINotification/GetNotificationsData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setNotificationsListsData(l_response[0]);
          console.log(l_response[0]);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function setNotificationsStatusDataLocally(
    pid: any,
    actiontype: any,
    index: any
  ) {
    let thisNotificationsListsData = [...notificationsListsData];

    if (actiontype == 1) {
      thisNotificationsListsData[index].IsRead =
        !thisNotificationsListsData[index].IsRead;
    } else if (actiontype == 2) {
      thisNotificationsListsData[index].IsFlag =
        !thisNotificationsListsData[index].IsFlag;
    }

    setNotificationsListsData(thisNotificationsListsData);
    setNotificationsStatusData(pid, actiontype);
  }

  function setNotificationsStatusData(pid: any, actiontype: any) {
    let object = {} as any;
    object.pid = pid;
    object.actiontype = actiontype;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFINotification/SetNotificationsStatusData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          getNotificationsTypeListsData();
          getNotificationsData();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function selectunSelectAll() {
    if (notificationsFilters.All) {
      notificationsFilters.NotificationsIDs = "-1";
    } else {
      notificationsFilters.NotificationsIDs = "";
    }

    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      All: !notificationsFilters.All,
    }));

    let thisNotificationsTypeList = [...notificationsTypeList];
    for (let i = 0; i < thisNotificationsTypeList.length; i++) {
      if (notificationsFilters.NotificationsIDs == "") {
        thisNotificationsTypeList[i].Selected = true;
      } else {
        thisNotificationsTypeList[i].Selected = false;
      }
    }

    setNotificationsTypeList(thisNotificationsTypeList);
  }

  function getUnreadNotification() {
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      Unread: !notificationsFilters.Unread,
    }));
  }

  function getFlaggedNotification() {
    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      Flagged: !notificationsFilters.Flagged,
    }));
  }

  function getSelectedNotificationType(index: any) {
    let thisNotificationsTypeList = [...notificationsTypeList];
    thisNotificationsTypeList[index].Selected =
      !thisNotificationsTypeList[index].Selected;

    let selectedIds = "";
    let allSelected = true;

    for (let i = 0; i < thisNotificationsTypeList.length; i++) {
      if (thisNotificationsTypeList[i].Selected) {
        selectedIds += thisNotificationsTypeList[i].PFINotificationTypeID + ",";
      } else {
        allSelected = false;
      }
    }

    if (selectedIds != "") {
      selectedIds = selectedIds.replace(/,$/, "");
    }

    if (selectedIds == "") {
      selectedIds = "-1";
    }

    setNotificationsTypeList(thisNotificationsTypeList);

    if (allSelected) {
      setNotificationsFilters((prevState: any) => ({
        ...prevState,
        All: true,
      }));
    } else {
      setNotificationsFilters((prevState: any) => ({
        ...prevState,
        All: false,
      }));
    }

    setNotificationsFilters((prevState: any) => ({
      ...prevState,
      NotificationsIDs: selectedIds,
    }));
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Actions Required</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items btns-notify">
              <a
                className={` ${
                  notificationsFilters.All ? "n-all-selected" : "unSelected"
                }`}
                onClick={() => selectunSelectAll()}
              >
                All
              </a>
              <a
                className={` ${
                  notificationsFilters.Unread
                    ? "n-unread-selected"
                    : "unSelected"
                }`}
                onClick={() => getUnreadNotification()}
              >
                Unread
              </a>
              <a
                className={` ${
                  notificationsFilters.Flagged
                    ? "n-flag-selected"
                    : "unSelected"
                }`}
                onClick={() => getFlaggedNotification()}
              >
                Flagged
              </a>
              {notificationsTypeList &&
                notificationsTypeList.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    <a
                      onClick={() => getSelectedNotificationType(index)}
                      className={` ${
                        item.Selected ? item.PTClass : "unSelected"
                      }`}
                    >
                      {item.Title}
                      {item.UnReadCount > 0 && (
                        <span className="notify-count">{item.UnReadCount}</span>
                      )}
                    </a>
                  </React.Fragment>
                ))}
            </div>
          </div>

          <div className="notify-main">
            {notificationsListsData &&
              notificationsListsData.map((item: any, index: any) => (
                <div
                  key={index}
                  className={
                    item.IsRead == true
                      ? "notify-row"
                      : "notify-row notify-Bold"
                  }
                >
                  <div className="flex-items n-flex-left">
                    <span className={"notify-type" + " " + item.PTClass}>
                      {item.NotificationType}
                    </span>
                    <a className="title-quarter"  href={item.SourceLink}>{item.Title1}</a>
                    <a className="title-retailer" href={item.SourceLink}>{item.Title2}</a>
                  </div>

                  <a className="title-notify" href={item.SourceLink}>{item.DisplayText}</a>
                  <div className="flex-items n-flex-right">
                    <a
                      onClick={() =>
                        setNotificationsStatusDataLocally(
                          item.PFINotificationUserID,
                          2,
                          index
                        )
                      }
                    >
                      {item.IsFlag && (
                        <img src="images/flagged.svg" width={26} height={27} />
                      )}
                      {!item.IsFlag && (
                        <img src="images/nflagged.svg" width={26} height={27} />
                      )}
                      {/* {item.IsFlag == true ? "flagged" : "notflagged"} -{" "} */}
                    </a>
                    <a
                      onClick={() =>
                        setNotificationsStatusDataLocally(
                          item.PFINotificationUserID,
                          1,
                          index
                        )
                      }
                    >
                      {!item.IsRead && (
                        <img src="images/unread.svg" width={31} height={30} />
                      )}
                      {item.IsRead && (
                        <img src="images/read.svg" width={32} height={32} />
                      )}
                      {/* {item.IsRead == true ? "read" : "unread"} */}
                    </a>
                    <div className="notify-time">
                      <img src="images/clock.svg" width={20} height={20} />
                      {moment(
                        AppContext.ConvertDateTimeToLocal(item.TimeAdded)
                      ).format("DD MMMM YYYY [at] hh:mm A z")}
                      {momenttimezone().tz(momenttimezone.tz.guess()).format('z')}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MyNotifications;
